export class TelephoneConfiguration {
  constructor (jsonObj) {
    this.defaultCountry = jsonObj.defaultCountry || 'AU'
    this.disabledFetchingCountry = jsonObj.disabledFetchingCountry || false
    this.placeholder = jsonObj.placeholder || 'Enter a phone number'
    this.required = jsonObj.required || false
    this.enabledCountryCode = jsonObj.enabledCountryCode || false
    this.enabledFlags = jsonObj.enabledFlags || true
    this.preferredCountries = jsonObj.preferredCountries || ['AU']
    this.onlyCountries = jsonObj.onlyCountries || ['AU', 'NZ']
    this.ignoredCountries = jsonObj.ignoredCountries || []
    this.autocomplete = jsonObj.autocomplete || 'tel'
    this.name = jsonObj.name || 'phone'
    this.maxLen = jsonObj.maxLen || 25
    this.wrapperClasses = jsonObj.wrapperClasses || 'form-control'
    this.inputClasses = jsonObj.inputClasses || ''
  }
}



// WEBPACK FOOTER //
// ./src/model/telephoneConfiguration.js